export default "__VITE_ASSET__DB7a_bhb__"